import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=5ee454ec&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee454ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ee454ec')) {
      api.createRecord('5ee454ec', component.options)
    } else {
      api.reload('5ee454ec', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=5ee454ec&scoped=true&", function () {
      api.rerender('5ee454ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4yC5S69HmQtDt/JS/comp/Accordion.vue"
export default component.exports